module.exports = __webpack_public_path__ + "static/img/img_6.a156dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_6.jpg
// module id = 113
// module chunks = 20